export default __webpack_public_path__ + "static/media/Priyanka Mishra.2985a0cb.jpg";